<template>
  <div
    class="zoox-component zoox-physical-card"
    :style="{background: backgroundImage ? `url(${backgroundImage})` : null}"
  >
    <div class="card-logo">
      <!--@slot Slot para customização da logo do card -->
      <slot name="logo"> logo </slot>
    </div>

    <div class="card-number">
      <span>{{ cardNumber[0] }}</span>
      <span>{{ cardNumber[1] }}</span>
      <span>{{ cardNumber[2] }}</span>
      <span>{{ cardNumber[3] }}</span>
    </div>

    <div class="card-info" :class="{'has-cvv': hasCvv}">
      <div class="owner">
        <div class="label">
          {{ $t('ownerName') }}
        </div>
        <div class="value">
          {{ name || '-' }}
        </div>
      </div>

      <div class="expiration">
        <div class="label">{{ $t('expiration') }}</div>
        <div class="value">{{ expiration }}</div>
      </div>

      <div v-if="hasCvv" class="cvv">
        <div class="label">{{ $t('cvv') }}</div>
        <div class="value">{{ cvv }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Componente que simula um cartão físico. Pode ser utilizado para exibir cartões
 * de crédito, cartões de saúde, entre outros desse tipo.
 * @displayName Physical Card
 */
export default {
  name: 'ZPhysicalCard',
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    number: {
      type: [Number, String],
      required: false,
      default: '',
    },
    expirationMonth: {
      type: [Number, String],
      required: false,
      default: '',
    },
    expirationYear: {
      type: [Number, String],
      required: false,
      default: '',
    },
    hasCvv: {
      type: Boolean,
      required: false,
      default: false,
    },
    cvv: {
      type: [Number, String],
      required: false,
      default: '',
    },

    backgroundImage: {
      type: String,
      required: false,
    },
  },

  computed: {
    expiration() {
      const monthString = this.expirationMonth.toString()
      const month =
        monthString.length === 0 ? '##' : monthString.padStart(2, '0')

      const yearString = this.expirationYear.toString()
      const year = yearString.length === 0 ? '##' : yearString.padStart(2, '0')

      return `${month}/${year}`
    },

    cardNumber() {
      const result = []
      const stringNumber = this.number.toString()

      for (let i = 0; i < 16; ++i) {
        if (typeof stringNumber[i] === 'undefined') {
          result.push('#')
        } else if (i >= 4 && i < 12) {
          result.push('•')
        } else {
          result.push(stringNumber[i])
        }
      }

      return result.join('').match(/[0-9#•]{4}/g)
    },
  },

  i18n: {
    messages: {
      pt: {
        expiration: 'Validade',
        ownerName: 'Nome do titular',
        cvv: 'CVV',
      },
      en: {
        expiration: 'Expiration',
        ownerName: 'Owner Name',
        cvv: 'cvv',
      },
      es: {
        expiration: 'Vencimiento',
        ownerName: 'Nombre del titular de la tarjeta',
        cvv: 'cvv',
      },
      fr: {
        expiration: "Date d'expiration",
        ownerName: 'Nom du propriétaire',
        cvv: 'CVV',
      },
      tr: {
        expiration: 'Son kullanma tarihi',
        ownerName: 'Sahip Adı',
        cvv: 'CVV',
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-physical-card {
  display: grid;
  grid-template-rows: 60px 65px 60px;
  grid-template-columns: 1fr;
  padding: 0 10px;
  place-items: center;
  color: var(--white);

  width: 100%;
  max-width: 320px;
  height: 185px;
  border-radius: 10px 10px;
  background: url('../../../assets/img/credit-card-background.png');
  background-size: 100%;
  background-size: cover;

  .card-logo {
    width: 100%;
    height: 100%;
    display: flex;
    margin-right: 20px;
    justify-content: flex-end;
    align-items: flex-end;

    img {
      max-width: 60px;
      max-height: 90%;
    }
  }

  .card-number {
    font-weight: 700;
    font-size: 1.25rem;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;
  }

  .card-info {
    display: grid;
    grid-template-columns: 2fr 1fr;
    width: 100%;
    justify-items: center;
    column-gap: 5px;
    place-items: center;
    &.has-cvv {
      grid-template-columns: 2fr 1fr min-content;
    }

    .owner {
      justify-self: start;
      padding-left: 10px;
      overflow-x: auto;

      .value {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 160px;
      }
    }

    .label {
      font-size: 0.6875rem;
      font-weight: 400;
      text-transform: uppercase;
    }

    .value {
      font-size: 0.9375rem;
      font-weight: 400;
    }
  }
}
</style>
